import {HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthStateService} from '@auth/states';
import {CompanyStateService} from '@core/states';
import {CONFIG} from '@core/utils';

export const companyHeaderInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authState = inject(AuthStateService);
  const companyState = inject(CompanyStateService);

  if (authState.isAdmin()) {
    return next(req);
  }

  if (req.headers.has('X-Selected-Company-ID')) {
    return next(req);
  }

  const normalizedPrefix = CONFIG.API_PREFIX.replace(/^\/+|\/+$/g, '');
  const apiPrefix = `/${normalizedPrefix}/`;

  const isApiV1 = req.url.includes(apiPrefix);
  if (isApiV1 && /\/api\/v1\/me(\/|$)/.test(req.url)) {
    return next(req);
  }
  if (!isApiV1) {
    return next(req);
  }

  const companyId = companyState.membership()?.company?.id;
  if (!companyId) {
    return next(req);
  }

  return next(req.clone({
    headers: req.headers.set('X-Selected-Company-ID', String(companyId))
  }));
};
